import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { CompanyAdminContact } from '@app/models/payroll/company/company-admin-contact';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { EmailColumn } from './columns/email.column';
import { ExtensionColumn } from './columns/extension.column';
import { NameColumn } from './columns/name.column';
import { PhoneColumn } from './columns/phone.column';

const deleteOption: MenuColumnItem = {
    label: 'delete',
    event: 'delete',
};

const editOption: MenuColumnItem = {
    label: 'edit',
    event: 'edit',
    forceMeatballsDisplay: true,
};

@Injectable()
export class CompanyAdminContactsTable extends Table {
    links = false;
    unnavigableLink = true;
    showMenuColumnOptions = true;
    defaultSortProperty = 'default';

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.columns = [new NameColumn(), new EmailColumn(), new PhoneColumn(), new ExtensionColumn()];
    }

    // Load nodes based on the parent node
    setDataSource(): void {
        this.paginator = new Paginator(CompanyAdminContact.param('company', this.auth.company.id));
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        if (this.paginator.total === 1) {
            return [editOption];
        }
        return [editOption, deleteOption];
    }
}
